export function preventWidow(text) {
    if (!text) return "";
    const words = text.trim().split(" ");
    if (words.length <= 3) return text;
    return [...words.slice(0, -2), words[words.length - 2] + "\u00A0" + words[words.length - 1]].join(" ");
}